import { PlaceholderIcon } from './PlaceholderIcon.tsx';

// The shimmer-while-loading / icon-on-error box shared by BlobImage and
// UserUploadedImage, so the loading and error UI is defined in one place.
export const ImagePlaceholderBox = ({
	errored,
	className,
	ariaLabel,
	role,
	ariaBusy,
}: {
	errored: boolean;
	className: string;
	ariaLabel?: string;
	role?: 'img';
	ariaBusy?: boolean;
}) => (
	<div
		className={className}
		role={role}
		aria-label={ariaLabel}
		aria-busy={ariaBusy}
	>
		{errored ? (
			<PlaceholderIcon />
		) : (
			<div
				className="animate-bridgeway-shimmer absolute inset-0 bg-gradient-to-r
					from-transparent via-white/40 to-transparent"
			/>
		)}
	</div>
);
